module.exports = __webpack_public_path__ + "img/user-circle.d40df9b0.png";